import { Area } from "./area.model";
import { Contract } from "./contract.model";
import { Department } from "./department.model";
import { Position } from "./position-role.model";

export class EmployeeRequest {
	id?:number;
	apellido: string;
	celular: string;
	citizenship: number;
	departamento: number;
	direccion: string;
	genero: string;
	identificacion: string;
	licencia: string;
	mail: string;
	municipio: number;
	nacimiento: string;//"1978-07-21T06:00:00.000Z"
	nombre: string;
	pais: number;
	telefono: string;
	visa: boolean = false;
	zona: number;
	registerDate: string;
	dischargeDate: string | null;
}

export class EmployeeResponse {
	active: boolean;
	apellido: string;
	bank: any;
	bank_account: any;
	celular: string;
	citizenship: number;
	code: string;
	company: number;
	contracted: false;
	creationDate: number;
	departamento: number;
	direccion: string;
	documento: any;
	foto: any;
	genero: string;
	id: number;
	identificacion: string;
	licencia: string;
	mail: string;
	municipio: number;
	nacimiento: number;//"1978-07-21T06:00:00.000Z"
	nombre: string;
	pais: number;
	penales: any;
	policiacos: any;
	workContract: any;
	psychometricTests: any;
	registedBy: number;
	telefono: string;
	visa: boolean = false;
	zona: number;
	registerDate: string;
	dischargeDate: string | null;
	constructor() {

	}
}

export interface EmploryeContractResponse {
	employee: EmployeeResponse;
	contact: Contract;
	position: Position;
	departament: Department;
	area: Area;
}